module.exports = __webpack_public_path__ + "img/ebcJpW.8c2fa4c7.svg";